// extracted by mini-css-extract-plugin
export default {"select":"Select_select__8W-bn","focus":"Select_focus__-dBY6"};